import { render, staticRenderFns } from "./EpisodeCard.vue?vue&type=template&id=66102c07&scoped=true&"
import script from "./EpisodeCard.vue?vue&type=script&lang=js&"
export * from "./EpisodeCard.vue?vue&type=script&lang=js&"
import style0 from "./EpisodeCard.vue?vue&type=style&index=0&id=66102c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66102c07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VHover,VIcon,VImg})
